import { render, staticRenderFns } from "./CardDocument.vue?vue&type=template&id=3064f4d4&scoped=true"
import script from "./CardDocument.vue?vue&type=script&lang=js"
export * from "./CardDocument.vue?vue&type=script&lang=js"
import style0 from "./CardDocument.vue?vue&type=style&index=0&id=3064f4d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3064f4d4",
  null
  
)

export default component.exports